<p-inputGroup>
	<p-inputGroupAddon *ngIf="preIcon">
		<i [ngClass]="preIcon"></i>
	</p-inputGroupAddon>
	<span class="form-group p-float-label">
		<input type="{{type}}"
			pInputText
			class="form-control input-field w-full {{extraClass}}"
			[required]="required"
			[ngClass]="{
				'ng-invalid': error,
				'pre-group': (preIcon != null),
			}"
			[id]="id" [name]="id"
			[(ngModel)]="value"
			(ngModelChange)="valueEmit();"
			[disabled]="disabled || (type == 'disabled')"
			[autocomplete]="autocomplete"
			[placeholder]="placeholder ?? ''"
			(focusout)="leaveFocus()"
		>
		<label *ngIf="label && !placeholder" for="{{ id }}">
			<span>{{ label }}</span>
			<span class="required" *ngIf="required">*</span>
		</label>
	</span>

</p-inputGroup>